import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertCircle, AlertTriangle, CheckCircle, InfoCircle, } from "@untitled-ui/icons-react";
import { PiInfo, PiX } from "react-icons/pi";
import { tv } from "tailwind-variants";
import { match } from "ts-pattern";
import { cn } from "../cn";
// todo: [standardise-colours]
export const alertVariants = tv({
    slots: {
        root: "rounded-md",
        title: "text-sm font-medium leading-normal",
        icon: "size-5",
    },
    variants: {
        kind: {
            default: {
                icon: "text-icon-primary",
                title: "text-primary",
                root: "bg-secondary",
            },
            info: {
                icon: "text-icon-info",
                title: "text-info",
                root: "bg-accent-info",
            },
            warning: {
                icon: "text-icon-warning",
                title: "text-warning",
                root: "bg-accent-warning",
            },
            error: {
                icon: "text-icon-danger",
                title: "text-danger",
                root: "bg-accent-danger",
            },
            success: {
                icon: "text-icon-success",
                title: "text-success",
                root: "bg-accent-success",
            },
        },
    },
    defaultVariants: { kind: "default" },
});
//TODO: This version should replace the old Alert component in a refactor
export function Alert({ title, description, actions, kind = "default", onClose, className, }) {
    const classes = alertVariants({ kind });
    const Icon = match(kind ?? "default")
        .with("info", () => PiInfo)
        .with("warning", () => AlertTriangle)
        .with("error", () => AlertCircle)
        .with("success", () => CheckCircle)
        .with("default", () => InfoCircle)
        .exhaustive();
    return (_jsxs("div", { className: cn(className, classes.root({
            className: "pointer-events-auto grid grid-flow-row grid-cols-[auto_1fr_auto] gap-x-3 gap-y-1 px-3 py-4",
        })), children: [_jsx("div", { className: "pt-px", children: _jsx(Icon, { className: classes.icon() }) }), title ? (_jsx("div", { className: classes.title({ className: "-mt-[1px] col-start-2" }), children: title })) : null, description ? (_jsx("div", { className: "col-start-2 text-primary text-sm leading-normal", children: description })) : null, actions ? _jsx("div", { className: "col-start-2 pt-2", children: actions }) : null, onClose ? (_jsx(PiX, { size: 16, className: "cursor-pointer", onClick: onClose })) : null] }));
}
/**
 * Use this for a consistent layout when adding an actions row on the bottom of an alert.
 *
 * Example:
 *
 * ```tsx
 * <AlertV2
 *    title="Information"
 *    description="Something"
 *    actions={
 *      <AlertActions>
 *        <Button>Dismiss</Button>
 *      </AlertActions>
 *    }
 *  />
 *
 * ```
 */
export function AlertActions(props) {
    return _jsx("div", { className: "flex justify-start gap-3", children: props.children });
}
